import * as React from "react";
import { useState } from "react";
import { DatePicker } from "../../../../react-core/Datepicker/DatePicker";
import { SelectEditor } from "../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../react-core/Html/TextBoxEditor";
import { addYears } from "../../../../react-core/utils/date";
import { ACCEPT_DATE_FORMATS, ContentDatePicker } from "../../../Shared/Entities/Constants/DateConstants";
import { HistoricWorkflowAction, IHistoricWorkflowSearchQuery } from "./Action/HistoricWorkflowSearchAction";
import { DemandTypeAction } from "./Action/DemandTypeSearchAction";
import { HistoricWorkflowResultTable } from "./HistoricWorkflowResultTable";
import { DemandTypeModel } from "../../../../Wrap/Models/Domains/Workflow/DemandTypeModel";
import { DemandType } from "../../../../Wrap/Models/Domains/Workflow/DemandType";

export const HistoricWorkflowDashboard = () => {
    const [data, setData] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [fromDate, setFromDate] = useState(addYears(new Date(), -1));
    const [toDate, setToDate] = useState(new Date());
    const [demandTypeList, setDemandTypeList] = useState<DemandTypeModel[]>([]);
    const [demandType, setDemandType] = useState<DemandType>(null);
    const [policyNumber, setPolicyNumber] = useState("");
    const [historicWorkflowSearchQuery, setHistoricWorkflowSearchQuery] = useState({});

    React.useEffect(() => {
        DemandTypeAction.searchHistoricWorkflows(
            {
                DemandType: 0,
                DemandLvl: 0,
                DemandTypeDs: "",
                DemandFullDs: "",
                StopDate: null,
            },
            (res) => {
                setDemandTypeList(res);
            }
        );
    }, []);

    const search = (query, currentPage, pageSize) => {
        setIsSearching(true);
        HistoricWorkflowAction.searchHistoricWorkflows(query, currentPage, pageSize, (res) => {
            setIsSearching(false);
            setData(res);
        });
    };

    const onHistoricWorkflowSearch = (query: IHistoricWorkflowSearchQuery) => {
        setHistoricWorkflowSearchQuery(query);
        search(query, 1, 10);
    };

    const onPageChange = (currentPage, pageSize) => {
        search(historicWorkflowSearchQuery, currentPage, pageSize);
    };

    return (
        <>
            <h1>Workflow Summary</h1>
            <hr />
            <div className="row">
                <div className="col-6">
                    <div className={"form-group search-form"}>
                        <SelectEditor
                            id="DemandType"
                            label="Demand type"
                            getText={(v) => {
                                return v != null ? v.DmndTypeDs : "All";
                            }}
                            // selected={clientType}
                            onChange={(v) => setDemandType(v?.DemandType)}
                            options={[null].concat(demandTypeList)}
                        />
                    </div>
                </div>
                <div className="col-6">
                    <div className={"form-group search-form"}>
                        <TextBoxEditor
                            label="Policy Number"
                            onChange={(v) => setPolicyNumber(v)}
                            value={policyNumber}
                            maxLength={100}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <DatePicker
                        label={"From"}
                        alwaysValidateOnUpdate={true}
                        atMost={{
                            // Can be selected at most yesterday
                            value: toDate,
                            errorMessage: ContentDatePicker.CannotBeInTheFuture,
                        }}
                        selected={fromDate}
                        showYearDropdown={true}
                        onChange={(d) => {
                            setFromDate(d);
                        }}
                        isClearable={true}
                        dateFormat={ContentDatePicker.DateFormat}
                        acceptDateFormats={ACCEPT_DATE_FORMATS}
                    />
                </div>
                <div className="col-3">
                    <DatePicker
                        label={"To"}
                        selected={toDate}
                        alwaysValidateOnUpdate={true}
                        atMost={{
                            value: new Date(),
                            errorMessage: ContentDatePicker.CannotBeInTheFuture,
                        }}
                        atLeast={{
                            value: fromDate,
                            errorMessage: ContentDatePicker.CannotBeInThePast,
                        }}
                        onChange={(d) => {
                            setToDate(d);
                        }}
                        showYearDropdown={true}
                        isClearable={true}
                        dateFormat={ContentDatePicker.DateFormat}
                        acceptDateFormats={ACCEPT_DATE_FORMATS}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-auto">
                    <button
                        className={`btn primary label-offset ${isSearching ? "is-busy" : ""}`}
                        onClick={() => {
                            setIsSearching(true);
                            onHistoricWorkflowSearch({
                                startDate: fromDate,
                                endDate: toDate,
                                demandType: demandType ?? DemandType.Undefined,
                                policyNumber: policyNumber,
                            });
                        }}
                    >
                        Search
                    </button>
                </div>
            </div>

            <HistoricWorkflowResultTable
                data={data}
                onPageChange={(currentPage, pageSize) => onPageChange(currentPage, pageSize)}
            />
        </>
    );
};
